<template>
  <div>
    <div class="avatarIdle">
      <table>
        <tr>
          <td>
            <img :src="'./static/Idle.png'"/>
          </td>
        </tr>
        <tr>
          <td>
            <div class="idleMessage">
              <span v-if="idleMessage">{{idleMessage}}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'Idle',
    components: {},
    props: ['idleMessage'],
    data() {
      return {}
    },
    methods: {},
    mounted() {
      // Vue.prototype.$api.checkCredentials(this)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/Idle.vue